/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import { action } from '@ember/object';
import Component from '@ember/component';
import { findBy } from '@linc-technologies/linced-common/utils/arrays';

export default class GroupsListCard extends Component {
  onDelete() {}

  @action
  noop() {}

  @action
  filterOtherGroups(groupings, group) {
    return !findBy(groupings, 'value', group.get('grouping'));
  }
}
